import { InstagramSpyOffer } from '../components/InstagramSpyOffer.tsx';

export default function Busca() {
  return <InstagramSpyOffer />;
}
